import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgForm } from '@angular/forms';
import { Transaction } from '../../models/transaction';
import { MerchantResponseComponent } from '../../merchant-response/merchant-response.component';
import { GlobalAppData } from '../../models/global-app-data';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MerchantResponseData } from '../../models/merchant-models';
import { LoadingService } from '../../services/loading.service';
import { PBBTransactionResponse } from '../../models/paybybank';
import { TransactionStatus } from '../../models/enums/constants';
import { SharedService } from '../../services/shared.service';
import { v4 as uuidv4 } from 'uuid';
import { PaybybankService } from '../../services/paybybank.service';
import {
  fetchNewtrnsctnAtmptPayByBank,
} from '../../common/utils';
import { PaymentRequestService } from '../../services/payment-request.service';
import { PaymentService } from '../../services/payment.service';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Constants } from '../../constants/constants';

@Component({
  selector: 'app-pay-by-bank-stub',
  templateUrl: './pay-by-bank-stub.component.html',
  styleUrls: ['./pay-by-bank-stub.component.css'],
  standalone: false,
})
export class PayByBankStubComponent implements OnInit {
  @Input() payByBankStatus: string = '';
  @Input() orderData?: Transaction;
  @Input() spcOscCode: string = '';

  billingInformation: FormGroup;
  @ViewChild(MerchantResponseComponent)
  merchantResponseComponent!: MerchantResponseComponent;
  @ViewChild('modalContent') modalContent?: TemplateRef<any>;
  @ViewChild('stubForm', { static: false }) stubForm: NgForm | undefined;

  private modalRef: NgbModalRef | null = null;

  paymentStatus = '';
  isStubEnabled = false;
  stubUserChoice = '';
  faLock = faLock;

  constructor(
    private fb: FormBuilder,
    public gd: GlobalAppData,
    private modalService: NgbModal,
    private loadingService: LoadingService,
    private sharedService: SharedService,
    private pbbService: PaybybankService,
    private paymentRequestService: PaymentRequestService,
    private paymentService: PaymentService
  ) {
    this.billingInformation = this.fb.group({
      nameDetails: this.fb.group({
        firstName: new FormControl(null, [Validators.minLength(1), Validators.required]),
        lastName: new FormControl(null, [Validators.minLength(1), Validators.required]),
        sameAsShippingContactName: new FormControl(),
      }),
      addressDetails: this.fb.group({
        streetAddress1: new FormControl(null, Validators.required),
        streetAddress2: new FormControl(),
        city: new FormControl(null, Validators.required),
        country: new FormControl('', Validators.required),
        region: new FormControl({ value: null, disabled: true }),
        zipcode: new FormControl({ value: null, disabled: true }),
        company: new FormControl(null),
        phoneNumber: new FormControl('', Validators.pattern(Constants.PHONENUMBER_VALIDATOR_PATTERN)),
        email: new FormControl('', Validators.pattern(Constants.EMAIL_VALIDATOR_PATTERN)),
        sameAsShippingContactAddress: new FormControl(),
      }),
    });
  }

  ngOnInit(): void {
    this.isStubEnabled = this.gd.isStubEnabled ?? false;
    console.log('ngOnInit: isStubEnabled=', this.isStubEnabled, 'billingInformation=', this.billingInformation);
  }

  createPayByBankPayment(): void {
    this.payByBankStatus = "approved"
    this.gd.paymentType = 'paybybank';
    this.payByBankTrnsctnDefaultAttemptNew();
  }

  private resetModalState(): void {
    this.stubUserChoice = '';
    if (this.stubForm) {
      this.stubForm.resetForm();
    }
  }

  private payByBankTrnsctnDefaultAttemptNew(): void {
    if (!this.billingInformation) {
      console.warn('BillingInformation is undefined');
      this.payByBankStatus = 'paymentError';
      this.handleError();
      return;
    }
    this.loadingService.setLoading(true,"internal")
    const paymentReq = this.paymentRequestService.getBillingPaymentRequest(this.billingInformation, true);
    sessionStorage.setItem('page', this.gd.attemptCount?.toString() ?? '0');
    sessionStorage.setItem('gd', Buffer.from(JSON.stringify(this.gd)).toString('base64'));

    this.paymentService.createPayment(paymentReq, this.gd.transId, '/paybybank').subscribe({
      next: (result: any) => {
        this.loadingService.setLoading(false, 'internal');
        let pbbTrans = result as PBBTransactionResponse;
        if (pbbTrans.transactionStatus === TransactionStatus.pbbapproved) {
          this.startPayByBankFlow();
        } else {
          this.payByBankStatus = 'failed';
          this.handleError();
        }
      },
      error: (error: any) => {
        this.loadingService.setLoading(false, 'internal');
        console.error('Error in createPayment:', error);
        this.payByBankStatus = 'paymentError';
        this.handleError();
      },
    });
  }

  private resetBillingInformation(): void {
    if (this.billingInformation) {
      this.billingInformation.reset();
      console.log('BillingInformation reset:', this.billingInformation);
    } else {
      console.warn('BillingInformation is undefined');
    }
  }

  private startPayByBankFlow(): void {
    if (this.isStubEnabled && this.modalContent) {
      this.resetBillingInformation();
      this.openModal();
    } else {
      console.warn('startPayByBankFlow: isStubEnabled=', this.isStubEnabled, 'modalContent=', this.modalContent);
      this.payByBankStatus = 'paymentError';
      this.handleError();
    }
  }

  private openModal(): void {
    if (!this.modalContent) {
      console.error('Modal content not found');
      this.payByBankStatus = 'paymentError';
      this.handleError();
      return;
    }

    this.gd.paymentType = 'paybybank';
    this.resetModalState();
    this.modalRef = this.modalService.open(this.modalContent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'pay-by-bank-modal',
    });

    this.modalRef.result.then(
      (choice: string) => {
        console.log('Modal closed with choice:', choice);
        this.loadingService.setLoading(true, 'internal');
        this.submitPayByBankStub(choice);
        this.resetModalState();
      },
      (reason) => {
        console.log('Modal dismissed with reason:', reason);
        this.handlePayByBankDecline();
        this.resetModalState();
      }
    );
  }

  private redirectToMerchant(urlVal: string): void {
    this.loadingService.setLoading(false,"internal")
    sessionStorage.clear();
    const paymentActionData: MerchantResponseData = {
      url: urlVal,
      orderTransaction: this.gd.orderTransaction,
      merchantPaymentReq: {},
    };

    if (this.merchantResponseComponent) {
      console.log('Redirecting to merchant with URL:', urlVal);
      this.merchantResponseComponent.sendResponseToMerchant('PAYBYBANK', paymentActionData);
    } else {
      console.error('MerchantResponseComponent not found');
    }
  }

  private redirectToMerchantSuccessURL(): void {
    this.loadingService.setLoading(false,"internal")
    const url =
      this.gd.orderTransaction?.order?.merchantSuccessURL ??
      this.gd.oscConfig?.successUrl ??
      '';
    if (url) this.redirectToMerchant(url);
    else {
      this.loadingService.setLoading(false,"internal")
      console.error('No success URL found');
    }
  }

  private redirectToMerchantRejectURL(): void {
    const url =
      this.gd.orderTransaction?.order?.merchantRejectURL ??
      this.gd.oscConfig?.rejectUrl ??
      '';
    if (url) this.redirectToMerchant(url);
    else console.error('No reject URL found');
  }

  private submitPayByBankStub(choice: string): void {
    if (!choice) {
      console.warn('No choice selected, handling as decline');
      this.loadingService.setLoading(false, 'internal');
      this.handlePayByBankDecline();
      return;
    }

    const orderId = this.gd.orderTransaction?.order?.epmsOrderId;
  
    let stubResponse: PBBTransactionResponse;

    const attemptCount = this.gd?.attemptCount ?? 1;
    const attempt = String(attemptCount).padStart(4, '0');
    
    switch (choice.toUpperCase()) {
      case 'APPROVED':
        stubResponse = {
          transactionStatus: TransactionStatus.pbbapproved,
          transactionStatusCode: 0,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'Approved',
          merchantTransactionId: `${orderId}${attempt}`,
          responseVerbiage: 'Approved',
          teleCheckDetails: {
            transactionId: this.generateRandom16Digit(),
            tckResponseCode: '07',
            approvalCode: '2071',
            achTransactionStatus: '1',
            dateTime: new Date().toISOString(),
          },
          errorDetails: [],
          security: null,
        };
        break;

      case 'CANCEL':
        stubResponse = {
          transactionStatus: 'ERROR',
          transactionStatusCode: 991006,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'User Cancelled',
          merchantTransactionId: `${orderId}${attempt}`,
          responseVerbiage: 'User Cancelled',
          errorDetails: null,
          security: null,
          teleCheckDetails: null,
        };
        break;

      case 'ERROR':
        stubResponse = {
          transactionStatus: 'ERROR',
          transactionStatusCode: 100,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'Input is invalid',
          merchantTransactionId: `${orderId}${attempt}`,
          responseVerbiage: 'Input is invalid',
          errorDetails: [
            {
              errorCode: 1020,
              errorField: '',
              errorReason: 'Invalid or missing value',
            },
          ],
          teleCheckDetails: {
            transactionId: this.generateRandom16Digit(),
            tckResponseCode: '27',
            approvalCode: null,
            achTransactionStatus: '0',
            dateTime: new Date().toISOString(),
          },
          security: null,
        };
        break;

      default:
        console.warn('Invalid choice, handling as decline:', choice);
        this.loadingService.setLoading(false, 'internal');
        this.handlePayByBankDecline();
        return;
    }

    this.processStubResponse(stubResponse);
  }

  private processStubResponse(response: PBBTransactionResponse): void {
    this.payByBankTrnsctnDefaultAttempt(response);
  }

  private handlePayByBankDecline(): void {
    const attemptCount = this.gd?.attemptCount ?? 1;
    const attempt = String(attemptCount).padStart(4, '0');

    this.loadingService.setLoading(false, 'internal');
    this.paymentStatus = 'declined';
    this.payByBankStatus = 'declined';
    this.resetBillingInformation();
    this.modalRef = null;

    const stubResponse: PBBTransactionResponse = {
      transactionStatus: 'ERROR',
      transactionStatusCode: 991006,
      referenceTransactionID: uuidv4(),
      transactionStatusDescription: 'User Cancelled',
      merchantTransactionId: `${this.gd.orderTransaction?.order?.epmsOrderId}${attempt}`,
      responseVerbiage: 'User Cancelled',
      errorDetails: null,
      security: null,
      teleCheckDetails: null,
    };

    this.fetchCaptureOnTransactionAttempt(stubResponse);
  }

  private payByBankTrnsctnDefaultAttempt(response: PBBTransactionResponse): void {
    if (!this.billingInformation) {
      console.warn('BillingInformation missing in payByBankTrnsctnDefaultAttempt');
      this.payByBankStatus = 'paymentError';
      this.handleError();
      return;
    }

    sessionStorage.setItem('page', this.gd.attemptCount?.toString() ?? '0');
    sessionStorage.setItem('gd', Buffer.from(JSON.stringify(this.gd)).toString('base64'));

    this.loadingService.setLoading(false, 'internal');

    if (response.transactionStatus === TransactionStatus.pbbapproved && response.transactionStatusCode === 0) {
      this.paymentStatus = 'paymentSuccess';
      this.payByBankStatus = 'approved';
    } else {
      this.payByBankStatus = response.transactionStatus ?? 'failed';
    }

    this.fetchCaptureOnTransactionAttempt(response);
  }

  private fetchCaptureOnTransactionAttempt(response: PBBTransactionResponse): void {
    this.pbbService
      .capturePayByBankOrder(this.gd.transId, response)
      .then(() => {
        if (response.transactionStatus === TransactionStatus.pbbapproved) {
          this.redirectToMerchantSuccessURL();
        } else {
          this.handleError();
        }
      })
      .catch((error) => {
        console.error('Error in capturePayByBankOrder:', error);
        this.payByBankStatus = 'Server Error';
        this.handleError();
      });
  }

  private handleError(): void {
    this.payByBankStatus = 'paymentError';
    this.resetBillingInformation();

    if (this.gd.attemptCount < (this.gd.oscConfig?.maxRejectAtmptCount ?? 0)) {
      console.log('Attempting retry, attemptCount:', this.gd.attemptCount);
      fetchNewtrnsctnAtmptPayByBank(this.sharedService, this.gd, this.loadingService)
        .then(() => {
          console.log('New transaction fetched for retry');
          this.loadingService.setLoading(false, 'internal');
        })
        .catch((error) => {
          console.error('Error in fetchNewtrnsctnAtmptPayByBank:', error);
          this.loadingService.setLoading(false, 'internal');
          this.redirectToMerchantRejectURL();
        });
    } else {
      console.log('Max attempts reached, redirecting to reject URL');
      this.redirectToMerchantRejectURL();
    }
  }

  onStubChoiceSelected(choice: string): void {
    this.stubUserChoice = choice;
    console.log('Stub choice selected:', choice);
  }

  private generateRandom16Digit(): string {
    return Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString();
  }
}